/**
 * @generated SignedSource<<c3ede85c4c781995603f5eaa2c558b4c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WorkspaceTodosArchivedQuery$variables = {
  after?: string | null;
  first?: number | null;
  query?: string | null;
  workspaceId: string;
};
export type WorkspaceTodosArchivedQuery$data = {
  readonly workspace: {
    readonly id: string;
    readonly " $fragmentSpreads": FragmentRefs<"WorkspaceTodosArchivedList_archiveTodos">;
  };
};
export type WorkspaceTodosArchivedQuery = {
  response: WorkspaceTodosArchivedQuery$data;
  variables: WorkspaceTodosArchivedQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "query"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "workspaceId"
},
v4 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "workspaceId"
  }
],
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v6 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  },
  {
    "kind": "Variable",
    "name": "query",
    "variableName": "query"
  }
],
v7 = [
  {
    "kind": "InlineFragment",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isoString",
        "storageKey": null
      }
    ],
    "type": "Date",
    "abstractKey": "__isDate"
  }
],
v8 = [
  {
    "kind": "Variable",
    "name": "workspaceId",
    "variableName": "workspaceId"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "WorkspaceTodosArchivedQuery",
    "selections": [
      {
        "alias": null,
        "args": (v4/*: any*/),
        "concreteType": "Workspace",
        "kind": "LinkedField",
        "name": "workspace",
        "plural": false,
        "selections": [
          (v5/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "WorkspaceTodosArchivedList_archiveTodos"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v3/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "WorkspaceTodosArchivedQuery",
    "selections": [
      {
        "alias": null,
        "args": (v4/*: any*/),
        "concreteType": "Workspace",
        "kind": "LinkedField",
        "name": "workspace",
        "plural": false,
        "selections": [
          (v5/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "hasArchivedTodo",
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v6/*: any*/),
            "concreteType": "TodoWorkspaceConnection",
            "kind": "LinkedField",
            "name": "archivedTodos",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "TodoWorkspaceEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "cursor",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TodoWorkspace",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v5/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "title",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "priority",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "UnzonedDate",
                        "kind": "LinkedField",
                        "name": "publishedAtDate",
                        "plural": false,
                        "selections": (v7/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "UnzonedDate",
                        "kind": "LinkedField",
                        "name": "archivedAtDate",
                        "plural": false,
                        "selections": (v7/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "UnzonedDate",
                        "kind": "LinkedField",
                        "name": "expireAtDate",
                        "plural": false,
                        "selections": (v7/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "status",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": (v8/*: any*/),
                        "kind": "ScalarField",
                        "name": "todoCount",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": (v8/*: any*/),
                        "kind": "ScalarField",
                        "name": "todosCompletedCount",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Image",
                        "kind": "LinkedField",
                        "name": "descriptionImages",
                        "plural": true,
                        "selections": [
                          (v5/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "thumbhash",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ImageSize",
                            "kind": "LinkedField",
                            "name": "sizes",
                            "plural": true,
                            "selections": [
                              (v5/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "url",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "urlExpiresAt",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "height",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "width",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "File",
                        "kind": "LinkedField",
                        "name": "descriptionFiles",
                        "plural": true,
                        "selections": [
                          (v5/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "type",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "isOrg",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "WorkspaceProduct",
                        "kind": "LinkedField",
                        "name": "linkedProducts",
                        "plural": true,
                        "selections": [
                          (v5/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "name",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "__typename",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "PageInfo",
                "kind": "LinkedField",
                "name": "pageInfo",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "endCursor",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasNextPage",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v6/*: any*/),
            "filters": [
              "query"
            ],
            "handle": "connection",
            "key": "WorkspaceTodosArchivedList_archiveTodos_archivedTodos",
            "kind": "LinkedHandle",
            "name": "archivedTodos"
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "883ed7671b44d22fbef8df3c952db954",
    "id": null,
    "metadata": {},
    "name": "WorkspaceTodosArchivedQuery",
    "operationKind": "query",
    "text": "query WorkspaceTodosArchivedQuery(\n  $workspaceId: ID!\n  $after: String\n  $first: Int\n  $query: String\n) {\n  workspace(id: $workspaceId) {\n    id\n    ...WorkspaceTodosArchivedList_archiveTodos\n  }\n}\n\nfragment FileIconBox_file on File {\n  type\n  isOrg\n  ...FileIcon_File\n}\n\nfragment FileIcon_File on File {\n  type\n  isOrg\n}\n\nfragment FormattedDate on Date {\n  __isDate: __typename\n  ...useFormattedDate\n}\n\nfragment Image_image on Image {\n  id\n  thumbhash\n  sizes {\n    id\n    url\n    urlExpiresAt\n    height\n    width\n  }\n}\n\nfragment ListItemDescriptionContentFiles_files on File {\n  id\n  ...FileIconBox_file\n}\n\nfragment ListItemDescriptionContentProducts_products on WorkspaceProduct {\n  id\n  ...WorkspaceTodoListItemProducts_WorkspaceProduct\n}\n\nfragment ListItemDescriptionContent_images on Image {\n  id\n  ...Image_image\n}\n\nfragment WorkspaceTodoListItemDescription_todo on TodoWorkspace {\n  title\n  descriptionImages {\n    ...ListItemDescriptionContent_images\n    id\n  }\n  descriptionFiles {\n    ...ListItemDescriptionContentFiles_files\n    id\n  }\n  linkedProducts {\n    ...ListItemDescriptionContentProducts_products\n    id\n  }\n}\n\nfragment WorkspaceTodoListItemProducts_WorkspaceProduct on WorkspaceProduct {\n  name\n}\n\nfragment WorkspaceTodoListItemStatus_todo on TodoWorkspace {\n  status\n  todoCount(workspaceId: $workspaceId)\n  todosCompletedCount(workspaceId: $workspaceId)\n}\n\nfragment WorkspaceTodosArchivedList_archiveTodos on Workspace {\n  id\n  hasArchivedTodo\n  archivedTodos(first: $first, after: $after, query: $query) {\n    edges {\n      cursor\n      node {\n        id\n        title\n        priority\n        publishedAtDate {\n          ...FormattedDate\n        }\n        archivedAtDate {\n          ...FormattedDate\n        }\n        expireAtDate {\n          ...FormattedDate\n        }\n        ...WorkspaceTodoListItemStatus_todo\n        ...WorkspaceTodoListItemDescription_todo\n        __typename\n      }\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment useFormattedDate on Date {\n  __isDate: __typename\n  isoString\n}\n"
  }
};
})();

(node as any).hash = "8278e326643baa7a2f0d71210d4b6da1";

export default node;
